import { useQuery } from "@tanstack/react-query";
import { getIrrCompanies } from "@/api";
import { IrrCompanyFund } from "@/types";

export const useIrrCompanies = () => {
  const query = useQuery<IrrCompanyFund[]>({
    queryKey: ["irrCompanies"],
    queryFn: () => getIrrCompanies(),
    staleTime: 1000 * 60 * 5,
  });

  return {
    ...query,
    data: query.data || [],
  }
};